import * as React from 'react';

import { useAtomValue } from 'jotai';

import * as state from '../../_state/loadDetails.state';
import {
  canLoadBeMarkedAsReceived,
  canLoadBeMarkedAsReviewed,
} from '../../utils/loadUtils';
import { loadDocuments } from '../_shared/availableDocuments';
import {
  DownloadDocumentsButton,
  PrintDocumentsButton,
} from '../_shared/FetchDocuments';
import { MarkLoadAsReceivedButton } from '../_shared/MarkLoadAsReceived';
import { MarkLoadAsReviewedButton } from '../_shared/MarkLoadAsReviewed';

export const LoadHeaderActions = () => {
  const loadId = useAtomValue(state.$loadId);
  const { data: load } = useAtomValue(state.$loadDetails);

  const canBeMarkedAsReceived = canLoadBeMarkedAsReceived(load);
  const canBeReviewed = canLoadBeMarkedAsReviewed(load);

  return (
    <div className="@LoadHeaderActions flex gap-2">
      <PrintDocumentsButton
        originKey="load-header"
        ids={[loadId]}
        showLabel={false}
        documents={loadDocuments}
      />
      <DownloadDocumentsButton
        originKey="load-header"
        compressedFileName={`load-${load?.id}`}
        ids={[loadId]}
        showLabel={false}
        documents={loadDocuments}
      />
      {canBeMarkedAsReceived && <MarkLoadAsReceivedButton loadIds={[loadId]} />}
      {canBeReviewed && <MarkLoadAsReviewedButton loadId={loadId} />}
    </div>
  );
};
